import "core-js/modules/es7.array.includes.js";
import React, { useEffect } from 'react';
import { printDeprecationWarning } from '@nerdwallet/deprecate';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';
var allowedBackgroundColors = ['neutral-lightest', 'yellow-lightest', 'green-lightest'];
/**
 * Standard NerdWallet wells emphasize or separate a group of information from other elements on a
 * page. The group is NOT interactive, but an interactive element can be added to the group
 * (e.g. `<Link/>`, `<Button/>`).
 */

export var Well = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'neutral-lightest' : _props$color,
      padding = props.padding;

  var getBackgroundColor = function getBackgroundColor(colorProp) {
    if (allowedBackgroundColors.includes(colorProp)) return colorProp; // color prop list has been updated using currency colors
    // we kept this validations for backwards-compatibility

    if (colorProp === 'gray') return 'neutral-lightest';
    if (colorProp === 'yellow') return 'yellow-lightest';
    return 'neutral-lightest';
  };

  useDeprecatedClassNameStylePropsWarning('Well', {
    className: className
  });
  useEffect(function () {
    if (color === 'gray' || color === 'yellow') {
      printDeprecationWarning({
        message: 'Non-Currency colors are deprecated. Use an allowable Currency color instead.'
      });
    }
  }, [color]);
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: getBackgroundColor(color),
    className: className,
    "data-currency": "Well",
    ref: ref,
    padding: padding
  }, children);
});
Well.displayName = 'Well';